module.exports = __webpack_public_path__ + "static/img/slide2_ban.54f014a.png";


//////////////////
// WEBPACK FOOTER
// ./static/wap_images/slide2_ban.png
// module id = TRCH
// module chunks = 1